module.exports = __webpack_public_path__ + "static/media/flag-hn.df6a13f1.webp";